// source: PublicIncreaseDepthsBatchV3Api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var PublicIncreaseDepthsV3Api_pb = require('./PublicIncreaseDepthsV3Api_pb.js');
goog.object.extend(proto, PublicIncreaseDepthsV3Api_pb);
goog.exportSymbol('proto.PublicIncreaseDepthsBatchV3Api', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PublicIncreaseDepthsBatchV3Api = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.PublicIncreaseDepthsBatchV3Api.repeatedFields_, null);
};
goog.inherits(proto.PublicIncreaseDepthsBatchV3Api, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PublicIncreaseDepthsBatchV3Api.displayName = 'proto.PublicIncreaseDepthsBatchV3Api';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.PublicIncreaseDepthsBatchV3Api.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PublicIncreaseDepthsBatchV3Api.prototype.toObject = function(opt_includeInstance) {
  return proto.PublicIncreaseDepthsBatchV3Api.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicIncreaseDepthsBatchV3Api} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicIncreaseDepthsBatchV3Api.toObject = function(includeInstance, msg) {
  var f, obj = {
itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api.toObject, includeInstance),
eventtype: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicIncreaseDepthsBatchV3Api}
 */
proto.PublicIncreaseDepthsBatchV3Api.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PublicIncreaseDepthsBatchV3Api;
  return proto.PublicIncreaseDepthsBatchV3Api.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicIncreaseDepthsBatchV3Api} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicIncreaseDepthsBatchV3Api}
 */
proto.PublicIncreaseDepthsBatchV3Api.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api;
      reader.readMessage(value,PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setEventtype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PublicIncreaseDepthsBatchV3Api.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PublicIncreaseDepthsBatchV3Api.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicIncreaseDepthsBatchV3Api} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PublicIncreaseDepthsBatchV3Api.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api.serializeBinaryToWriter
    );
  }
  f = message.getEventtype();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated PublicIncreaseDepthsV3Api items = 1;
 * @return {!Array<!proto.PublicIncreaseDepthsV3Api>}
 */
proto.PublicIncreaseDepthsBatchV3Api.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.PublicIncreaseDepthsV3Api>} */ (
    jspb.Message.getRepeatedWrapperField(this, PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api, 1));
};


/**
 * @param {!Array<!proto.PublicIncreaseDepthsV3Api>} value
 * @return {!proto.PublicIncreaseDepthsBatchV3Api} returns this
*/
proto.PublicIncreaseDepthsBatchV3Api.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.PublicIncreaseDepthsV3Api=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PublicIncreaseDepthsV3Api}
 */
proto.PublicIncreaseDepthsBatchV3Api.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.PublicIncreaseDepthsV3Api, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.PublicIncreaseDepthsBatchV3Api} returns this
 */
proto.PublicIncreaseDepthsBatchV3Api.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional string eventType = 2;
 * @return {string}
 */
proto.PublicIncreaseDepthsBatchV3Api.prototype.getEventtype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.PublicIncreaseDepthsBatchV3Api} returns this
 */
proto.PublicIncreaseDepthsBatchV3Api.prototype.setEventtype = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto);
